import { createApp, h } from "vue";

import SbAlert from "./SbAlert.vue";
import SbBadge from "./SbBadge.vue";
import SbButton from "./SbButton.vue";
import SbCollapse from "./SbCollapse.vue";
import SbDropdown from "./SbDropdown.vue";
import SbDropdownItem from "./SbDropdownItem.vue";
import SbDropdownItemButton from "./SbDropdownItemButton.vue";
import SbFormCheckbox from "./SbFormCheckbox.vue";
import SbFormGroup from "./SbFormGroup.vue";
import SbFormInput from "./SbFormInput.vue";
import SbFormSelect from "./SbFormSelect.vue";
import SbFormSelectOption from "./SbFormSelectOption.vue";
import SbInputGroup from "./SbInputGroup.vue";
import SbInputGroupAppend from "./SbInputGroupAppend.vue";
import SbInputGroupPrepend from "./SbInputGroupPrepend.vue";
import SbInputGroupText from "./SbInputGroupText.vue";
import SbModal from "./SbModal.vue";
import SbPagination from "./SbPagination.vue";
import SbSelect from "./SbSelect.vue";
import SbSpinner from "./SbSpinner.vue";
import SbTab from "./SbTab.vue";
import SbTable from "./SbTable.vue";
import SbTableLite from "./SbTableLite.vue";
import SbTabs from "./SbTabs.vue";
import SbToast from "./SbToast.vue";
import { modalController, toastController } from "./controllers";
import { SbModalDirective, SbToggleDirective } from "./directives";

export const components = {
    SbAlert,
    SbBadge,
    SbButton,
    SbFormCheckbox,
    SbFormGroup,
    SbFormInput,
    SbFormSelect,
    SbFormSelectOption,
    SbInputGroup,
    SbInputGroupAppend,
    SbInputGroupPrepend,
    SbInputGroupText,
    SbSelect,
    SbSpinner,
    SbCollapse,
    SbDropdown,
    SbDropdownItem,
    SbDropdownItemButton,
    SbModal,
    SbTab,
    SbTabs,
    SbToast,
    SbPagination,
    SbTable,
    SbTableLite,
};

export default {
    install(app) {
        Object.values(components).forEach((component) => {
            app.component(component.name, component);
        });
        app.directive("sb-modal", SbModalDirective);
        app.directive("sb-toggle", SbToggleDirective);

        modalController.configureConfirm((message, options, resolve) => {
            const container = document.createElement("div");
            document.body.appendChild(container);
            let settled = false;
            let modal;
            let confirmApp;

            const finish = (result) => {
                if (!settled) {
                    settled = true;
                    resolve(result);
                }
                modal?.hide();
            };
            const hidden = () => {
                if (!settled) {
                    settled = true;
                    resolve(null);
                }
                confirmApp.unmount();
                container.remove();
            };

            confirmApp = createApp({
                render() {
                    return h(
                        SbModal,
                        {
                            ref: (instance) => { modal = instance; },
                            modelValue: true,
                            title: options.title || "Confirm",
                            onHidden: hidden,
                        },
                        {
                            default: () => h("p", String(message)),
                            footer: () => [
                                h("button", {
                                    class: ["btn", `btn-${options.cancelVariant || "secondary"}`],
                                    onClick: () => finish(false),
                                }, options.cancelTitle || "Cancel"),
                                h("button", {
                                    class: ["btn", `btn-${options.okVariant || "primary"}`],
                                    onClick: () => finish(true),
                                }, options.okTitle || "OK"),
                            ],
                        }
                    );
                },
            });
            confirmApp.mount(container);
        });
        app.config.globalProperties.$sbModal = modalController;

        toastController.configure((toast) => {
            const container = document.createElement("div");
            container.className = "position-fixed p-3";
            container.style.cssText = "top: 0; right: 0; z-index: 1080";
            document.body.appendChild(container);

            let toastApp;
            const hidden = () => {
                toastApp.unmount();
                container.remove();
            };
            toastApp = createApp(SbToast, { ...toast, onHidden: hidden });
            toastApp.mount(container);
        });
        app.config.globalProperties.$sbToast = toastController;
    },
};
